import React from 'react'
import styles from './Messages.scss'
import {Icon} from 'common/LegacyIcon'
import {Link} from 'react-router'

export const errorMessage = <div className={styles.infoMessage}>
  <Icon i='farthingWithFlat' size={300} />
  <h3>Bummer</h3>
  <p>
    We had some trouble loading this page for you. Try refreshing the page, and
    if you still get this message don't hesitate to <a href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>get in touch</a>.
  </p>
</div>

export const noReportsMessage = <div className={styles.infoMessage}>
  <div className={styles.multibike}>
    <Icon i='rwgps' size={50} />
    <Icon i='rwgps' size={50} />
    <Icon i='rwgps' size={50} />
    <Icon i='rwgps' size={50} style={{opacity: 0.25}} />
    <Icon i='rwgps' size={50} />
  </div>
  <h3>Nothing to see here</h3>
  <p>
    There are no ride reports to show for this page. Perhaps you should <Link to='/ride_reports/new'>write one</Link>?
  </p>
</div>
